import { CategoryDownloadDto, ContentController, ContentPostContentLocationDownloadDto, ContentPostContentTypeDownloadDto, ContentPostMediaTypeDownloadDto, ControllerHelper } from 'collaboration-service';
import { LoaderInline } from 'imaginarity-react-ui';
import * as React from 'react';
import { BaseEditItem, useDispatchGPE, useSelectorGPE } from './GeneralPostEdit';
import { GeneralPostEditActions } from './GeneralPostEditStateHandling';
import * as _ from "lodash";
interface PostUpdaterProps<T> {
    post?: T;
    children: React.ReactNode;
    groupId?: string;
    isPost?: boolean;
}

const PostUpdater = <T extends BaseEditItem = BaseEditItem>(p: PostUpdaterProps<T>) => {
    const { post, groupId, isPost } = p;
    const groupid = groupId ?? post?.group_id;
    const type = post?.type ?? "";
    const [loading, setLoading] = React.useState<boolean>(false);
    const d = useDispatchGPE();
    const statePost = useSelectorGPE((state) => state.post);

    React.useEffect(() => {
        return () => {
            //console.log('cleanUp => ');
            d(GeneralPostEditActions.batch([
                GeneralPostEditActions.setPost(undefined),
                GeneralPostEditActions.setOriginalPost(undefined),
            ]))
        }
    }, [d]);

    //console.log('statePost => ', statePost);
    //console.log('post => ', post);


    React.useEffect(() => {

        if (statePost?.id !== post?.id) {
            //console.log("setting post! => ", post)
            d(GeneralPostEditActions.batch([
                GeneralPostEditActions.setPost(post),
                GeneralPostEditActions.setOriginalPost(post),
            ]))
        }
    },
        [d, post, statePost])


    React.useEffect(() => {
        const load = async () => {
            //console.log("PostUpdater.tsx::51 => reload?");
            let grouptype = "CMS";
            if (type === "ContentPost")
                grouptype = "LANDING PAGE SMART MOBILITY";
            if (type === "NewsInformationElement")
                grouptype = "CUSTOMER INFORMATION"
            if (type === "TubePost")
                grouptype = "TUBE";
            if (groupid) {
                const [c, l, t, m, c1, l1, t1, m1] = await ControllerHelper
                    .addCall({ grouptype }, ContentController.GetCategoriesForAllGroupsByGroupType, true)
                    .addCall({ grouptype }, ContentController.GetContentPostContentLocationForAllGroupsByGroupType, true)
                    .addCall({ grouptype }, ContentController.GetContentPostContentTypeForAllGroupsByGroupType, true)
                    .addCall({ grouptype }, ContentController.GetContentPostMediaTypeForAllGroupsByGroupType, true)
                    .addCall({ groupid }, ContentController.GetCategories, true)
                    .addCall({ groupid }, ContentController.GetContentPostContentLocations, true)
                    .addCall({ groupid }, ContentController.GetContentPostContentType, true)
                    .addCall({ groupid }, ContentController.GetContentPostMediaTypes, true)
                    .execute<CategoryDownloadDto[], ContentPostContentLocationDownloadDto[], ContentPostContentTypeDownloadDto[], ContentPostMediaTypeDownloadDto[], CategoryDownloadDto[], ContentPostContentLocationDownloadDto[], ContentPostContentTypeDownloadDto[], ContentPostMediaTypeDownloadDto[]>();
                d(GeneralPostEditActions.batch([
                    GeneralPostEditActions.setCategories(_.uniqBy(_.union(c, c1), u => u.id)),
                    GeneralPostEditActions.setLocations(_.uniqBy(_.union(l, l1), u => u.id)),
                    GeneralPostEditActions.setContentTypes(_.uniqBy(_.union(t, t1), u => u.id)),
                    GeneralPostEditActions.setMediaTypes(_.uniqBy(_.union(m, m1), u => u.id)),
                ]))
            };
            setLoading(false);

        }
        setLoading(true);
        load();
    }, [groupid, d, type, isPost])

    if (statePost === undefined || loading)
        return <LoaderInline active />;
    //console.log('PostUpdate => ', statePost);
    return <>
        {p.children}
    </>;
}
export default PostUpdater;